// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"1c8e271b","99":"1008b9c5","648":"91214c58","821":"9ce689de","867":"b22df4a9"}[chunkId] + ".chunk.css";
};